// extracted by mini-css-extract-plugin
export default {"dialogTitle":"IdleTimer_dialogTitle__cUQ19","dialogContent":"IdleTimer_dialogContent__kgAgd","dialogNumber":"IdleTimer_dialogNumber__rP857"};